export const ACTION_UPDATE_APPOINTMENT = '/booking-portal/Appointment/UpdateAppointment';